/**
 * ChatGPT-style peek cap for artifact markdown.
 *
 * Short stubs stay at 20rem (`max-h-80`). Longer write-ups get +20% (24rem,
 * `max-h-96`) so the first screen shows more before Expand.
 */

export const ARTIFACT_PEEK_SHORT_CLASS = 'relative max-h-80 overflow-hidden'
export const ARTIFACT_PEEK_TALL_CLASS = 'relative max-h-96 overflow-hidden'

const SHORT_CHAR_LIMIT = 180
const SHORT_LINE_LIMIT = 2

export function isArtifactPeekShort(markdown: string): boolean {
  const trimmed = markdown.trim()
  if (!trimmed) {
    return true
  }
  if (/\{\{(plot|quotes_strip|quote):/.test(trimmed)) {
    return false
  }
  const lines = trimmed.split(/\n+/).filter((line) => line.trim().length > 0)
  return trimmed.length <= SHORT_CHAR_LIMIT && lines.length <= SHORT_LINE_LIMIT
}

export function artifactPeekClass(markdown: string): string {
  return isArtifactPeekShort(markdown)
    ? ARTIFACT_PEEK_SHORT_CLASS
    : ARTIFACT_PEEK_TALL_CLASS
}
